
import { defineComponent } from 'vue'
import VipModify from '@/views/dashboard/_notify-popup/vip-modify/vip-modify.vue'
import UpdatePassword from '@/views/dashboard/_notify-popup/update-password/update-password.vue'
import AuthExpired from '@/views/dashboard/_notify-popup/auth-expired/auth-expired.vue'

export default defineComponent({
  components: { AuthExpired, UpdatePassword, VipModify },
})
